// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@adl/XDL/Utilities";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        size: 12,
        css: css`
            line-height: 18px;
            padding: 7px 0;
            width: auto;
            min-width: 50px;
            text-align: left;
        `,
    },
    iconProps: {
        color: "common.ui7",
        css: css`
            justify-content: center;
            && svg {
                height: 10px;
                width: 10px;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: auto;
            ${IconWrapper} {
                height: 27px;
            }
        `,
        formField: css`
            width: 200px;
            ${xScreen("lte", "md")} {
                flex-direction: column;
                width: 50%;
                label {
                    padding-top: 0;
                }
            }
        `,
        inputSelect: css`
            height: 30px;
        `,
    },
};
